import React from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import {throttle} from '@learningblocks/exp-constants/lib/Utilities';

const EVENT_RESIZE = 'resize';

export function Animation(props) {
  const element = React.useRef();

  const [anime, setAnime] = React.useState(undefined);

  const [height, setHeight] = React.useState('auto');
  const [width, setWidth] = React.useState('auto');

  const onResize = () => {
    throttle(() => setAnimeDimentions(), 15, 'animation');
  };

  const setAnimeDimentions = () => {
    if (anime) {
      const parentHeight = element.current.parentElement.clientHeight;
      const parentWidth = element.current.parentElement.clientWidth;
      setHeight(parentHeight.toString() + 'px');
      setWidth(parentWidth.toString() + 'px');
      if (parentHeight === 0) setHeight('auto');
      if (parentWidth === 0) setWidth('auto');
    }
  };

  React.useEffect(() => {
    if (!anime) {
      const a = getLottieInstance(element.current, props.animation);
      a.goToAndStop(props.frame, true);
      setAnime(a);
      setAnimeDimentions();
    }
  }, []);

  React.useEffect(() => {
    window.addEventListener(EVENT_RESIZE, onResize);
    return () => {
      window.removeEventListener(EVENT_RESIZE, onResize);
    };
  }, []);

  React.useEffect(() => {
    if (anime) {
      anime.goToAndStop(props.frame, true);
    }
  }, [props.frame]);

  return (
    <div className={props.className}>
      <div style={{height: height, width: width}} ref={element} />
    </div>
  );
}

function getLottieInstance(container, animation) {
  if (animation.isPath)
    return lottie.loadAnimation({
      loop: false,
      autoplay: false,
      container: container,
      path: animation.animationData,
    });
  else
    return lottie.loadAnimation({
      loop: false,
      autoplay: false,
      container: container,
      animationData: animation.animationData,
    });
}

Animation.propTypes = {
  /**
   * current frame of animation
   */
  frame: PropTypes.number,
  /**
   * animation file
   */
  animation: PropTypes.shape({
    /**
     * specifies if animation provided is url or file
     */
    isPath: PropTypes.bool,
    /**
     * animation file
     */
    animationData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
};
